import React from "react";
import { Helmet } from "react-helmet-async";
const ReturnAndExchangePolicy = () => {
  return (
    <>
      <Helmet>
        <title>Return & Exchange Policy - SabbaFarm (Sabba Farm)</title>

        {/* Meta Description */}
        <meta
          name="description"
          content="Read SabbaFarm's (Sabba Farm) Return and Exchange Policy to learn about returns, refunds, and product exchange procedures for our agricultural products."
        />

        {/* Meta Keywords (cleaned and concise) */}
        <meta
          name="keywords"
          content="SabbaFarm, Sabba Farm, return policy, exchange policy, refund policy, agricultural product returns, online farm product exchange"
        />

        {/* Indexing Allowed */}
        <meta name="robots" content="index, follow" />

        {/* Canonical URL */}
        <link rel="canonical" href="https://sabbafarm.com/returnpolicy" />

        {/* Open Graph Tags */}
        <meta
          property="og:title"
          content="Return & Exchange Policy - SabbaFarm (Sabba Farm)"
        />
        <meta
          property="og:description"
          content="Understand SabbaFarm's (Sabba Farm) return, refund, and product exchange terms for a hassle-free shopping experience."
        />
        <meta property="og:url" content="https://sabbafarm.com/returnpolicy" />
        <meta property="og:type" content="website" />
      </Helmet>

      <div className="p-6 max-w-7xl mx-auto text-gray-800 shadow-lg mb-16">
        <h1 className="text-3xl font-bold mb-2 text-green-700" id="returnp">
          RETURN AND EXCHANGE POLICY
        </h1>
        <p className="mb-2">
          Return Policy
          <br />
          We do not offer returns for goods once they have been delivered.
          However, we understand that there may be instances of mismatched
          products or receipt of defective or expired items. In such cases, we
          offer replacements free of cost, subject to availability in our stock.
        </p>

        <h2 className="text-2xl font-semibold mt-6 mb-2 text-green-700">
          Exceptions and Rules
        </h2>
        <ul className="list-disc pl-6 space-y-1 mb-2">
          <li>
            All items for return or exchange must be unused and in their
            original condition, with all original labels and packaging intact,
            and should not be broken or tampered with.
          </li>
          <li>
            Exchanges are permitted only if your address is eligible for an
            exchange by our logistics team.
          </li>
          <li>
            If a product comes with a free gift or offer and you wish to return
            the item, the maximum refund or free item MRP will be debited until
            satisfactory receipt of all associated free gifts or offer items.
          </li>
          <li>
            For self-shipped returns, please ensure that the items are securely
            packed to prevent loss or damage during transit. We recommend using
            a reliable courier service for all self-shipped returns.
          </li>
          <li>
            Perishable goods such as seeds and flowers cannot be returned if the
            packet is opened or damaged.
          </li>
          <li>
            Products must be returned within 7 days from the day of delivery. To
            initiate a return, please contact our customer care team at
            +91-9866113858. A receipt or proof of purchase is required to
            complete the return process.
          </li>
        </ul>
        <h2 className="text-2xl font-semibold mt-6 mb-2 text-green-700">
          Refunds
        </h2>
        <p>
          Once your return is received and inspected, we will send you an email
          notification regarding the approval or rejection of your refund. If
          approved, your refund will be processed, and a credit will be applied
          to your original method of payment within 7 to 10 working days.
        </p>

        <h2 className="text-2xl font-semibold mt-6 mb-2 text-green-700">
          Late or Missing Refunds
        </h2>
        <p>
          If you haven't received your refund within the specified timeframe,
          please check your bank account first. You may then contact your credit
          card company or bank for further assistance. If necessary, reach out
          to us at customercare@sabbafarm.com for support.
        </p>

        <h2 className="text-2xl font-semibold mt-6 mb-2 text-green-700">
          Exchanges{" "}
        </h2>
        <p className="mb-2">
          We only replace items if they are defective or damaged. If you need to
          exchange a product for the same item, please email us at
          customercare@sabbafarm.com
        </p>
      </div>
    </>
  );
};

export default ReturnAndExchangePolicy;
